
(function () {
  // ── Read Liquid-injected values from the DOM bridge element ──
  const dataEl = document.getElementById('parasite-fb-data');
  const sectionId = dataEl ? dataEl.dataset.sectionId : '';
  const expectedDelivery = dataEl ? dataEl.dataset.expectedDelivery : '';
  // Subscription price rendered by Liquid from the live selling plan allocation
  const subPriceFromLiquid = dataEl ? parseFloat(dataEl.dataset.subPrice) : NaN;
  const sectionSelector = '#shopify-section-' + sectionId;

  // ══════════════════════════════════════════════════════════════
  // 1. CAROUSEL  (previously first <script> block)
  // ══════════════════════════════════════════════════════════════
  var scrollToElement = function (element) {
    var $innerListItem = $(element),
      $parentDiv = $(element).parent();

    $parentDiv.scrollTop(
      $parentDiv.scrollTop() +
      $innerListItem.position().top -
      $parentDiv.height() +
      $innerListItem.height()
    );
  };

  var setNavHeight = function () {
    setTimeout(function () {
      $('.carousel-nav-list').height(
        $(sectionSelector + ' .productwithtext-carousel')
          .find('.slick-slide[data-slick-index=0] img')
          .height() -
        $('.carousel-btn').height() * 2
      );
    }, 250);
  };

  $(sectionSelector + ' .productwithtext-carousel').slick({
    arrows: false,
    fade: false,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true,
          prevArrow: '<i class="slick-prev fa fa-chevron-left" aria-hidden="true"></i>',
          nextArrow: '<i class="slick-next fa fa-chevron-right" aria-hidden="true"></i>',
        },
      },
    ],
  });

  $(sectionSelector + ' .carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(sectionSelector + ' .carousel-nav-item').removeClass('active');
    $(sectionSelector + ' .carousel-nav-item[data-slide="' + nextSlide + '"]').addClass('active');
    scrollToElement(
      $(sectionSelector + ' .carousel-nav-item[data-slide="' + nextSlide + '"]')[0]
    );
  });

  $(document).on('click', sectionSelector + ' .carousel-nav-item', function (e) {
    var slideNumber = parseInt($(this).attr('data-slide'));
    $(sectionSelector + ' .productwithtext-carousel').slick('slickGoTo', slideNumber);
  });

  $(document).on('click', sectionSelector + ' .prev-img', function () {
    $(sectionSelector + ' .productwithtext-carousel').slick('slickPrev');
  });

  $(document).on('click', sectionSelector + ' .next-img', function () {
    $(sectionSelector + ' .productwithtext-carousel').slick('slickNext');
  });

  // ══════════════════════════════════════════════════════════════
  // 2. PRICE DISPLAY & PURCHASE TYPE  (previously second <script> block)
  // ══════════════════════════════════════════════════════════════
  // One-time prices are the funnel prices checkout charges after the fixed-amount codes applied below
  // (tested 28 Oct 2026): PRST1 1 kit = $117.40, PRST2 2 kits = $199.58, PRST4 4 kits = $375.68.
  // If those codes change, update these and the matching totals in custom-product-form-parasite-cleanse-kit.liquid.
  // Struck-through totals use the kit's live price; 170.95 is the 1-kit "value" anchor (_compare_at_price 17095).
  // The multi-kit savings also count the $34.95 free gift, as the original copy did.
  var round2 = function (n) { return Math.round(n * 100) / 100; };
  var priceFromLiquid = dataEl ? parseFloat(dataEl.dataset.price) : NaN;
  var unitprice = isNaN(priceFromLiquid) ? 118.95 : priceFromLiquid;
  var giftvalue = 34.95;
  var totalprice1 = 170.95;
  var regularprice1 = 117.4;
  var savingprice1 = round2(totalprice1 - regularprice1).toFixed(2);
  var subprice = isNaN(subPriceFromLiquid) ? round2(unitprice * 0.9) : subPriceFromLiquid;
  var totalprice2 = round2(unitprice * 2);
  var regularprice2 = 199.58;
  var savingprice2 = round2(totalprice2 + giftvalue - regularprice2).toFixed(2);
  var totalprice4 = round2(unitprice * 4);
  var regularprice4 = 375.68;
  var savingprice4 = round2(totalprice4 + giftvalue - regularprice4).toFixed(2);
  var buytext = 'BUY ONCE & SAVE';

  $('.freq-option').click(function () {
    $('.freq-option').removeClass('selecteds');
    var radios = $('input.favour_input:checked').val();

    $(this).each(function () {
      if ($(this).hasClass('subsripts')) {
        $('div#qtyOptions').css('display', 'none');
        $('#qtyOptions li.bag1').click();
        $('.total-price').text('$' + totalprice1.toFixed(2));
        $('.regular-price').text('$' + subprice.toFixed(2));
        $('.saving-text').text('Save $' + (totalprice1 - subprice).toFixed(2) + ' Today');
        $('.atc-btn--total_price').text('($' + subprice.toFixed(2) + ')');
        $('.subs-purchase').text('AUTOSHIP & SAVE 40% OFF TODAY');
        $('.regular-price-one-time.atc-btn-price').text(
          '$' + regularprice1.toFixed(2) + ' ' + buytext + ' $' + savingprice1
        );
      } else {
        $('#qtyOptions').css('display', 'block');

        if (radios == '1') {
          $('.total-price').text('$' + totalprice1.toFixed(2));
          $('.regular-price').text('$' + regularprice1.toFixed(2));
          $('.saving-text').text('Save $' + savingprice1 + ' Today');
          $('.atc-btn--total_price').text('($' + regularprice1.toFixed(2) + ')');
          $('.regular-price-one-time.atc-btn-price').text(
            '$' + regularprice1.toFixed(2) + ' ' + buytext + ' $' + savingprice1
          );
        } else if (radios == '2') {
          $('.total-price').text('$' + totalprice2.toFixed(2));
          $('.regular-price').text('$' + regularprice2.toFixed(2));
          $('.saving-text').text('Save $' + savingprice2 + ' Today');
          $('.atc-btn--total_price').text('($' + regularprice2.toFixed(2) + ')');
          $('.regular-price-one-time.atc-btn-price').text(
            '$' + regularprice2.toFixed(2) + ' ' + buytext + ' $' + savingprice2
          );
        } else {
          $('.total-price').text('$' + totalprice4.toFixed(2));
          $('.regular-price').text('$' + regularprice4.toFixed(2));
          $('.saving-text').text('SAVE 40% TODAY PLUS FREE SHIPPING');
          $('.atc-btn--total_price').text('($' + regularprice4.toFixed(2) + ')');
          $('.regular-price-one-time.atc-btn-price').text(
            '$' + regularprice4.toFixed(2) + ' ' + buytext + ' $' + savingprice4
          );
        }
      }

      $(this).addClass('selecteds');
    });
  });

  $(document).ready(function () {
    $('#qtyOptions li').click(function () {
      $('#qtyOptions li').removeClass('selected');
      $('#qtyOptions li input').removeAttr('checked');

      $(this).each(function () {
        $(this).addClass('selected');
        $(this).find('input.favour_input').prop('checked', true);
        var radios2 = $(this).find('input.favour_input:checked').val();
        var radios_purchase = $('input[name="purchase_type"]:checked').val();

        if (radios2 == '1') {
          if (radios_purchase == 'onetime') {
            $('.total-price').text('$' + totalprice1.toFixed(2));
            $('.regular-price').text('$' + regularprice1.toFixed(2));
            $('.saving-text').text('Save 25% Today');
            $('.atc-btn--total_price').text('($' + regularprice1.toFixed(2) + ')');
            $('.regular-price-one-time.atc-btn-price').text(
              '$' + regularprice1.toFixed(2) + ' ' + buytext + ' $' + savingprice1
            );
          } else {
            $('.total-price').text('$' + totalprice1.toFixed(2));
            $('.regular-price').text('$' + subprice.toFixed(2));
            $('.saving-text').text('Save $' + (totalprice1 - subprice).toFixed(2) + ' Today');
            $('.atc-btn--total_price').text('($' + subprice.toFixed(2) + ')');
            $('.regular-price-one-time.atc-btn-price').text('$' + regularprice1.toFixed(2) + ' ');
          }
        } else if (radios2 == '2') {
          $('.total-price').text('$' + totalprice2.toFixed(2));
          $('.regular-price').text('$' + regularprice2.toFixed(2));
          $('.saving-text').text('Save $' + savingprice2 + ' Today');
          $('.atc-btn--total_price').text('($' + regularprice2.toFixed(2) + ')');
          $('.regular-price-one-time.atc-btn-price').text(
            '$' + regularprice2.toFixed(2) + ' ' + buytext + ' $' + savingprice2
          );
        } else {
          $('.total-price').text('$' + totalprice4.toFixed(2));
          $('.regular-price').text('$' + regularprice4.toFixed(2));
          $('.saving-text').text('SAVE $' + savingprice4 + ' TODAY PLUS FREE SHIPPING');
          $('.atc-btn--total_price').text('($' + regularprice4.toFixed(2) + ')');
          $('.regular-price-one-time.atc-btn-price').text(
            '$' + regularprice4.toFixed(2) + ' ' + buytext + ' $' + savingprice4
          );
        }
      });
    });
  });

  // ── Product data array (used by checkout_redirect) ──
  const product_obj_arr = [
    { qty: 1, regular_price: 170.95, price: 117.4, saving: '25%', label: '1-Kit' },
    { qty: 2, regular_price: 275.3, price: 119.9, saving: '$155.40', price_each: '$59.95 EACH', label: '2-Kits' },
    { qty: 4, regular_price: 431.6, price: 199.8, saving: '$231.80', price_each: '$49.95 EACH', label: '4-Kits' },
  ];

  const qty_radios = document.querySelectorAll('input[name="quantity"]');
  const priceEl = document.querySelector('.saving-price .regular-price');
  const saving_text = document.querySelector('.saving-price .saving-text');
  const reg_price = document.querySelector('.total-price');
  const purchase_type = document.querySelectorAll('input[name="purchase_type"]');
  const qty_options = document.getElementById('qtyOptions');
  const atc_btn = document.getElementById('addToCartBtn');
  const atc_btn_total_price = document.querySelector('.atc-btn--total_price');

  function getQtyData(qty) {
    return product_obj_arr.find((obj) => obj.qty === qty);
  }

  // ══════════════════════════════════════════════════════════════
  // 3. PURCHASE TYPE TOGGLE  (previously inline in window.load)
  // ══════════════════════════════════════════════════════════════
  function purchaseType() {
    purchase_type.forEach((btn) => {
      btn.addEventListener('change', function (event) {
        if (event.target.type === 'radio' && event.target.checked) {
          console.log('selected purchase type: ' + event.target.value);
          qty_options.style.display = event.target.value === 'onetime' ? 'block' : 'none';
        }
      });
    });
  }

  function showDiscountPopup(code) {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed; inset: 0;
      background: rgba(0,0,0,0.5);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    // Create popup box
    overlay.innerHTML = `
      <div style="
        background: #fff;
        padding: 2rem;
        border-radius: 8px;
        max-width: 400px;
        text-align: center;
        font-family: inherit;
      ">
        <h2 style="margin: 0 0 0.5rem;">🎉 Your discount is active!</h2>
        <p style="margin: 0 0 1rem;">
          Your FREE book is being delivered. Get 40% off Organifi Parasite Cleanse Today Only!
        </p>
        <button id="discount-popup-close" style="
          background: #000;
          color: #fff;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
        ">Start Shopping</button>
      </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('discount-popup-close').addEventListener('click', function () {
      overlay.remove();
    });

    // Also close on overlay click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.remove();
    });
  }

  // ══════════════════════════════════════════════════════════════
  // 4. CHECKOUT REDIRECT  (previously inline in window.load)
  //    Liquid value `expected_delivery` is read from data attribute
  // ══════════════════════════════════════════════════════════════
  function checkout_redirect() {
    if (new URLSearchParams(window.location.search).get('ref') === 'email') {
      showDiscountPopup('PARASITE40');
    }

    if (!atc_btn) return;

    atc_btn.addEventListener('click', function () {
      let cart_items = [];
      let selected_purchase_type = document.querySelector('input[name="purchase_type"]:checked').value;
      let checkout_url = 'https://organifishop.com/cart/clear?return_to=/cart/add?';
      let discount_code = null;
      const selectedQty = document.querySelector('input[name="quantity"]:checked').value;

      if (selectedQty == '2') {
        let item = {
          id: 44848956899514,
          quantity: 2,
          properties: { expected_delivery: expectedDelivery },
        };
        let giftItem = {
          id: 44139252252858,
          quantity: 1,
          properties: {
            _compare_at_price: '3443',
            is_prepaid: false,
            expected_delivery: expectedDelivery,
            paid_offer_free: 'free_products',
          },
        };
        cart_items.push(item);
      } else if (selectedQty == '4') {
        let item = {
          id: 44848956899514,
          quantity: 4,
          properties: { expected_delivery: expectedDelivery },
        };
        let giftItem = {
          id: 44139252252858,
          quantity: 1,
          properties: {
            _compare_at_price: '3443',
            is_prepaid: false,
            expected_delivery: expectedDelivery,
            paid_offer_free: 'free_products',
          },
        };
        cart_items.push(item);
      } else {
        let item = {
          id: 44848956899514,
          quantity: 1,
          properties: {
            _compare_at_price: '17095',
            is_prepaid: false,
            expected_delivery: expectedDelivery,
          },
        };
        let giftItem = {
          id: 44139252252858,
          quantity: 1,
          properties: {
            _compare_at_price: '3443',
            is_prepaid: false,
            expected_delivery: expectedDelivery,
            paid_offer_free: 'free_products',
          },
        };
        if (selected_purchase_type == 'subscription') {
          item.selling_plan = 3610181818;
        }
        cart_items.push(item);
      }

      console.log('cart_items: ' + JSON.stringify(cart_items));

      if (cart_items.length) {
        cart_items.forEach((item) => {
          if (item.quantity != '0') {
            checkout_url += '%26items[][id]=' + item.id + '%26items[][quantity]=' + item.quantity;
            if (item.selling_plan != null) {
              checkout_url += '%26items[][selling_plan]=' + item.selling_plan;
            }
            if (item.properties != null) {
              for (const key in item.properties) {
                checkout_url += '%26items[][properties][' + key + ']=' + item.properties[key];
              }
            }
          }
        });

        checkout_url += '%26return_to=/checkout';

        const purchaseVal = document.querySelector('input[name="purchase_type"]:checked').value;
        if (selectedQty == '1' && purchaseVal == 'onetime') {
          checkout_url += '?discount=PRST1';
          discount_code = 'PRST1';
        } else if (selectedQty == '2' && purchaseVal == 'onetime') {
          checkout_url += '?discount=PRST2';
          discount_code = 'PRST2';
        } else if (selectedQty == '4' && purchaseVal == 'onetime') {
          checkout_url += '?discount=PRST4';
          discount_code = 'PRST4';
        } else if (selectedQty == '1' && purchaseVal == 'subscription') {
          checkout_url += '?discount=PRST1S';
          discount_code = 'PRST1S';
        }
      }

      console.log('checkout_url: ' + checkout_url);

      fetch('/cart/clear.js', { method: 'POST' }).then((response) => {
        if (!response.ok) throw new Error('Error clearing the cart');
        console.log('Cart cleared successfully');
        document.querySelector('.cart-section').parentNode.style.display = 'none';

        CartJS.addItems(cart_items, {
          success: function () {
            window.location.href = discount_code ? '/checkout?discount=' + discount_code : '/checkout';
          },
          error: function () {
            console.log('There was a problem adding to the cart!');
            document.querySelector('.cart-section').parentNode.style.display = 'block';
          },
        });
      });
    });
  }

  // ══════════════════════════════════════════════════════════════
  // 5. CONVERT EXPERIMENTS TRACKING  (from inline script in ATC section)
  // ══════════════════════════════════════════════════════════════

  $('.product-form__submit').on('click', function () {
    window._conv_q = window._conv_q || [];
    _conv_q.push(['triggerConversion', '100232312']);
    if ($('og-optin-toggle').is('[subscribed]')) {
      console.log('Subscribed Event Triggered');
      _conv_q.push(['triggerConversion', '100232316']);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      purchaseType();
      checkout_redirect();
    });
  } else {
    purchaseType();
    checkout_redirect();
  }
})();
